import axiosClient from '../http/axios-client';

const CollectionService = (collectionName) => {
  return {

    getTotalEntriesOfCollection(params = {}) {
      const defaultParams = { filterQuery: {} };
      const queryParams = {
        ...defaultParams,
        ...params,
      };
      const { filterQuery, ...rest } = queryParams;
      return axiosClient.get(`${ collectionName }/count`, { params: {
        ...rest,
        ...filterQuery,
      } });
    },

    get(params = {}) {
      // if i have defaultParams or not
      const defaultParams = { page: 0, limit: 10, filterQuery: {}, sort: `${ 'updated_at' }:DESC` };
      const queryParams = {
        ...defaultParams,
        ...params,
      };
      const { page, limit, sort: _sort, filterQuery, ...rest } = queryParams;
      const _limit = limit;// 100
      const _start = _limit * page;

      // transform page to limit and offset (limit always 100 entries by default)
      // limit = 100, offset = 100 * page
      return axiosClient.get(`${ collectionName }`, { params: {
        ...rest,
        ...filterQuery,
        _limit,
        _start,
        _sort,
      } });
    },

    getById(id) {
      return axiosClient.get(`${ collectionName }/${ id }`);
    },

    update(payload) {
      return axiosClient.put(`${ collectionName }/${ payload.id }`, payload);
    },

    delete(payload) {
      return axiosClient.delete(`${ collectionName }/${ payload.id }`);
    },

    create(payload) {
      return axiosClient.post(`${ collectionName }/`, payload);
    },

  };
};

export default CollectionService;
